import { ProductCarousel } from "../../carousal/ProductCarousel";
import section06Styles from "./section06.module.css";

const products = [
  {
    title: "Self-Awareness",
    description: "Discover your core personality traits, talents, and areas for improvement. Understand why you may face certain patterns or challenges in life.",
    image: "./Icon/self-awareness.png",
  },
  {
    title: "Improved Decision-Making",
    description: "Gain clarity on the best times for major decisions (e.g., career changes, investments, or relationships).",
    image: "./Icon/decision.png",
  },
  {
    title: "Relationship Harmony",
    description: "Learn how your elements interact with those of others to improve communication and deepen connections.",
    image: "./Icon/relationship.png"
  },
  {
    title: "Career and Financial Guidance",
    description: "Identify industries or roles aligned with your elemental strengths. Recognize opportunities for financial growth or challenges to prepare for.",
    image: "./Icon/career.png",
  },
  {
    title: "Health and Well-being",
    description: "Understand how elemental imbalances can affect your health and how to restore harmony.",
    image: "./Icon/health.png",
  },
  {
    title: "Balance and Growth",
    description: "Align your life with the natural rhythms of the Five Elements for greater stability and fulfillment.",
    image: "./Icon/balance.png",
  },
];

export const Section06 = () => {
  return (
    <section id="5" className={section06Styles.section06}>
      <ProductCarousel products={products} />
    </section>
  );
};
